/**
 * Gets the generated test ID name for the specified ID.
 * @param id The ID to get the test ID for.
 */
export function getTestId(id: string): string;

/**
 * Gets the generated test ID name for the specified ID and prefix.
 * @param id The ID to get the test ID for.
 * @param prefix The test ID prefix.
 */
export function getTestId(id: string, prefix: string): string;

/**
 * Gets the generated test ID name for the specified ID and optional prefix.
 * @param id The ID to get the test ID for.
 * @param prefix The optional test ID prefix.
 */
export function getTestId(id: string, prefix?: string): string {
  return prefix ? `${prefix}-${id}` : id;
}
